const FEDEX_GROUND_SERVICE_ID = '50';
export const canUseFedExGroundCollect = (serviceId) => serviceId && serviceId.toString() === FEDEX_GROUND_SERVICE_ID;
